import { createLazyOrchestrator } from 'owa-bundling';
import { goToNextSurfaceDateRange } from 'owa-calendar-module-commanding';
import { getNextSurfaceDateRange } from 'owa-calendar-surface-surface-store';
import { processDateRangeChange } from 'owa-calendar-surface-view-store';

export const goToNextSurfaceDateRangeOrchestrator = createLazyOrchestrator(
    goToNextSurfaceDateRange,
    'goToNextSurfaceDateRange_CLONE',
    () => {
        const newDateRange = getNextSurfaceDateRange();
        processDateRangeChange(newDateRange);
    }
);
